export default __webpack_public_path__ + "8d39d242349e9e23c1d7c7c0613109b8.jpg";